// ServiceTwo.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import WOW from 'wowjs';
import {
  FaFileAlt,
  FaPercentage,
  FaCalculator,
  FaChartLine,
  FaBusinessTime,
  FaNetworkWired,
  FaBalanceScale,
  FaHandshake,
  FaMoneyBillWave
} from 'react-icons/fa';
import './ServiceTwo.css';
import KnowMoreButton from './KnowMoreButton';

function ServiceTwo() {
  useEffect(() => {
    const wow = new WOW.WOW({ live: false });
    wow.init();
  }, []);

  

  const services = [
  {
    icon: <FaBalanceScale color="black" size={60} />,
    title: "Accounting & Financial Advisory",
    desc: "The accounting department plays a vital role in every organization.",
    hash: "#accounting"   // ✅ changed from "#advisory"
  },
  {
    icon: <FaFileAlt color="black" size={60} />,
    title: "Audit and assurance",
    desc: "Financial statement audits are mainly performed to satisfy specific organizational or external demands.",
    hash: "#audit"
  },
  {
    icon: <FaChartLine color="black" size={60} />,
    title: "Business performance review",
    desc: "Gain valuable insights into your company’s efficiency, profitability, and growth potential through our in-depth performance analysis.",
    hash: "#performance"
  },
  {
    icon: <FaBusinessTime color="black" size={60} />,
    title: "Business set-up services",
    desc: "Starting a new company is always an exciting journey...",
    hash: "#setup"
  },
  {
    icon: <FaMoneyBillWave color="black" size={60} />,
    title: "Corporate Tax Services",
    desc: "Bahrain has introduced Corporate Tax as part of its evolving tax framework...",
    hash: "#corporate"  // ✅ changed from "#tax"
  },
  {
    icon: <FaNetworkWired color="black" size={60} />,
    title: "ERP consulting",
    desc: "Selecting the right solution at the right price can be a daunting challenge.",
    hash: "#erp"
  },
  {
    icon: <FaHandshake color="black" size={60} />,
    title: "Merger & Acquisition",
    desc: "We bridge the gap between organizations seeking investors and investors looking for opportunities...",
    hash: "#merger"
  },
  {
    icon: <FaCalculator color="black" size={60} />,
    title: "Outsourced accounting",
    desc: "Access expert financial management without the overhead...",
    hash: "#outsourced"   // ✅ changed from "#accounting"
  },
  {
    icon: <FaPercentage color="black" size={60} />,
    title: "VAT consulting",
    desc: "Comprehensive VAT consulting tailored to your business...",
    hash: "#vat"
  }
];


  return (
    <div className="service-area tmp-section-gap">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-head">
              <div className="section-sub-title color-secondary center-title">
                <span>OUR SERVICES</span>
              </div>
              <h2 className="section-title split-collab">Our Provided Services</h2>
            </div>
          </div>
        </div>

        <div className="row g-5">
          {services.map((service, idx) => (
            <div
              key={idx}
              className="col-lg-4 col-md-6 col-sm-6 col-12 wow slideInUp"
              data-wow-duration=".8s"
              data-wow-delay={`.${(idx % 3) + 1}s`}
            >
              <div className="service-inner financial-service-inner">
                <div className="icon">{service.icon}</div>
                <div className="content">
                  <h2 className="title">{service.title}</h2>
                  <p style={{textAlign:"justify"}} className="description">{service.desc}</p>
                  <div className="three--dot">
                    <div className="dot dot-one" />
                    <div className="dot dot-two" />
                    <div className="dot dot-two" />
                  </div>
                </div>
                <Link
                  to={`/ServiceDetails${service.hash}`}
                  className="btn btn-primary mt-2 know-more-btn"
                  style={{ fontSize: '18px', padding: '12px 24px', borderRadius: '8px' }}
                >
                  Know More
                </Link>
                <Link to={`/ServiceDetails${service.hash}`} className="over_link" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ServiceTwo;
